<header [class.header-pf]="!isCasasBahia">
  <div *ngIf="isCasasBahia && !isWebView" class="header-lines-cb">
    <span class="line-1"></span>
    <span class="line-2"></span>
  </div>

  <div *ngIf="!(isMinorThanTablet | async).matches" class="header-content">
    <a (click)="goToHome()" style="all: unset; cursor: pointer;">
      <div *ngIf="isCasasBahia" class="brand-cb-text">
        <span class="title">Pagamento e renegociação</span>
        <span class="subtitle">Carnê e cartão</span>
      </div>
      <img *ngIf="!isCasasBahia" src="/assets/images/layout/header-logo-pf-white.svg" alt="Logo Ponto"
        class="brand-pf-text">
    </a>
    <div *ngIf="!isCasasBahia" class="user-info">
      <span>Bem vindo {{username}}</span>
    </div>
    <div class="actions">
      <a [href]="whatsAppUrl" (click)="handleGaEvent()" target="_blank" data-context="renegociacao" data-collect="atendimento whatsApp">
        <button mat-icon-button matTooltip="Atendimento whatsApp" color="primary">
          <img src="/assets/images/icone_whatts.png" height="24px" width="24px" alt="Atendimento whatsApp">
        </button>
      </a>

      <button mat-icon-button [matMenuTriggerFor]="menuNotificacao" (menuOpened)="markNotificationsAsRead()"
        (menuClosed)="fetchNotifications()" color="primary" matTooltip="Notificações" aria-label="Notificações">
        <mat-icon [matBadge]="totalUnviewedNotifications" matBadgeSize="small" matBadgeColor="accent"
          [matBadgeHidden]="totalUnviewedNotifications === 0">
          notifications_none
        </mat-icon>
      </button>

      <section>
        <mat-menu #menuNotificacao="matMenu" class="custom-menu-notificacao-panel" xPosition="before">
          <div class="notificacao-header">
            <div class="header-container">
              <h2>Notificações </h2>
              <span>{{ totalNotifications }}</span>
            </div>
            <mat-divider></mat-divider>
          </div>

          <div class="notificacao-list">
            <div *ngIf="notifications.length === 0" class="sem-notificaoes">
              <mat-icon>
                notifications_none
              </mat-icon>
              <span>Suas notificações serão exibidas aqui</span>
            </div>
            <div *ngFor="let notification of notifications" class="notificacao-list-item"
              [class.notificacao-list-item-nao-lida]="!notification.visualizado && isCasasBahia"
              [class.notificacao-list-item-nao-lida-pf]="!notification.visualizado && !isCasasBahia">
              <p>
                {{notification.mensagem}}
              </p>
              <span>{{notification.data | date:'longDate'}}</span>
            </div>
          </div>
        </mat-menu>
      </section>

      <button *ngIf="!isAutoLogin" mat-icon-button matTooltip="Meu Cadastro" color="primary" (click)="goToProfilePage()"
        aria-label="Meu Cadastro">
        <mat-icon class="material-symbols-outlined">account_circle</mat-icon>
      </button>

      <button mat-icon-button matTooltip="Sair" color="primary" (click)="logout()" aria-label="Sair da aplicação">
        <mat-icon>login</mat-icon>
      </button>
    </div>
  </div>

  <div class="header-line-pf" *ngIf="!isCasasBahia"></div>

  <div *ngIf="(isMinorThanTablet | async).matches" class="mobile-header" [class.is-web-view]="isWebView">
    <button *ngIf="isCasasBahia" (click)="handleGoBack()" class="go-back-btn cb"
      [ngStyle]="{'visibility': isHomePage ? 'hidden' : 'visible'}">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <button *ngIf="!isCasasBahia" (click)="handleGoBack()" class="go-back-btn pf">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div class="actions">
      <a [attr.href]="whatsAppUrl" (click)="handleGaEvent()" target="_blank" >
        <button  type="button" mat-icon-button matTooltip="Atendimento whatsApp" color="primary">
          <img src="/assets/images/icone_whatts.png" height="24px" width="24px" alt="Atendimento whatsApp">
        </button>
      </a>

      <button *ngIf="!isAutoLogin" mat-icon-button matTooltip="Meu Cadastro" color="primary" (click)="goToProfilePage()"
        aria-label="Meu Cadastro">
        <mat-icon>perm_identity</mat-icon>
      </button>

      <button mat-icon-button [matMenuTriggerFor]="menuNotificacao" (menuOpened)="markNotificationsAsRead()"
        (menuClosed)="fetchNotifications()" color="primary" matTooltip="Notificações" aria-label="Notificações">
        <mat-icon [matBadge]="totalUnviewedNotifications" matBadgeSize="small" matBadgeColor="accent"
          [matBadgeHidden]="totalUnviewedNotifications === 0">
          notifications_none
        </mat-icon>
      </button>

      <section>
        <mat-menu #menuNotificacao="matMenu" class="custom-menu-notificacao-panel" xPosition="before">
          <div class="notificacao-header">
            <div class="header-container">
              <h2>Notificações </h2>
              <span>{{ totalNotifications }}</span>
            </div>
            <mat-divider></mat-divider>
          </div>

          <div class="notificacao-list">
            <div *ngIf="notifications.length === 0" class="sem-notificaoes">
              <mat-icon>
                notifications_none
              </mat-icon>
              <span>Suas notificações serão exibidas aqui</span>
            </div>
            <div *ngFor="let notification of notifications" class="notificacao-list-item"
              [class.notificacao-list-item-nao-lida]="!notification.visualizado && isCasasBahia"
              [class.notificacao-list-item-nao-lida-pf]="!notification.visualizado && !isCasasBahia">
              <p>
                {{notification.mensagem}}
              </p>
              <span>{{notification.data | date:'longDate'}}</span>
            </div>
          </div>
        </mat-menu>
      </section>

      <button *ngIf="!isWebView" mat-icon-button matTooltip="Sair" color="primary" (click)="logout()"
        aria-label="Sair da aplicação">
        <mat-icon>exit_to_app</mat-icon>
      </button>
    </div>

  </div>
</header>

<div *ngIf="(isMinorThanTablet | async).matches" class="brand-out-header">
  <a (click)="goToHome()" style="all: unset; cursor: pointer;">
    <div *ngIf="isCasasBahia && isHomePage" class="brand-cb-text">
      <span class="title">Pagamento e renegociação</span>
      <span class="subtitle">Carnê e cartão</span>
    </div>
    <img *ngIf="!isCasasBahia" src="/assets/images/layout/header-logo-pf-dark.svg" alt="Logo Casas Bahia"
      class="brand-cb-text">
  </a>
</div>

<app-breadcrumb *ngIf="isCasasBahia && !(isMinorThanTablet | async).matches"></app-breadcrumb>